import styled, { keyframes } from 'styled-components';
import { STATIC_IMAGE_URLS, STEP_ANIMATION_DURATION_MS } from 'modules/core/constants';
import { COLORS } from 'modules/core/theme/colors';

const spin = keyframes`
  from { transform: rotate(-90deg); }
  to { transform: rotate(270deg); }
`;

export const ProgressTrackWrap = styled.div`
  position: relative;
  margin-bottom: 8px;
  padding-top: 8px;
`;

export const ProgressTrack = styled.div`
  height: 12px;
  border-radius: 999px;
  background: ${COLORS.GREY_42};
  overflow: visible;
  position: relative;
`;

export const ProgressFill = styled.div<{ $pct: number }>`
  height: 100%;
  width: ${({ $pct }) => `${$pct}%`};
  max-width: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, ${COLORS.BLUE_5} 0%, ${COLORS.BLUE_20} 50%, ${COLORS.BLUE_21} 100%);
  transition: width ${STEP_ANIMATION_DURATION_MS}ms ease-out;
`;

export const ProgressCar = styled.span<{ $pct: number }>`
  position: absolute;
  top: -8px;
  left: ${({ $pct }) => `clamp(0px, calc(${$pct}% - 14px), calc(100% - 28px))`};
  width: 28px;
  height: 18px;
  background: url(${STATIC_IMAGE_URLS.addInventoryModalLogo}) center / contain no-repeat;
  transition: left ${STEP_ANIMATION_DURATION_MS}ms ease-out;
`;

export const Wrapper = styled.div`
  margin-bottom: 10px;
`;

export const Steps = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const Step = styled.div`
  white-space: nowrap;
  font-weight: 400;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StepLine = styled.div`
  flex: 1;
  height: 2px;
  background: ${COLORS.GREY_41};
  margin: 0 12px;
  position: relative;
  overflow: hidden;
  border-radius: 4px;
`;

export const StepCircleWrapper = styled.div<{ $size: number }>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const BaseCircle = styled.circle`
  transition: fill 300ms ease, stroke 300ms ease;
`;

export const CheckmarkPath = styled.path`
  transition: stroke 250ms ease;
`;

export const SpinnerCircle = styled.circle`
  transform-box: fill-box;
  transform-origin: center;
  animation: ${spin} 1s linear infinite;
`;
